// ================ Action types ================ //

import { getFollowers, insertFollowers, updateFollowers } from "../../util/api";
import { storableError } from "../../util/errors";
import { parse } from "../../util/urlHelpers";
import { showUser } from "../ProfilePage/ProfilePage.duck";

export const FOLLOW_COMPANY_REQUEST = 'app/FollowCompanyPage/FOLLOW_COMPANY_REQUEST';
export const FOLLOW_COMPANY_SUCCESS = 'app/FollowCompanyPage/FOLLOW_COMPANY_SUCCESS';
export const FOLLOW_COMPANY_ERROR = 'app/FollowCompanyPage/FOLLOW_COMPANY_ERROR';
export const UPDATE_FOLLOWER_REQUEST = 'app/FollowCompanyPage/UPDATE_FOLLOWER_REQUEST';
export const UPDATE_FOLLOWER_SUCCESS = 'app/FollowCompanyPage/UPDATE_FOLLOWER_SUCCESS';
export const UPDATE_FOLLOWER_ERROR = 'app/FollowCompanyPage/UPDATE_FOLLOWER_ERROR';

// ================ Reducer ================ //

const initialState = {
  followCompany: null,
  followCompanyInProgress: false,
  followCompanyShowError: null,
  updateFollowerInProgress: false,
  updateFollowerError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FOLLOW_COMPANY_REQUEST:
      return { ...state, followCompanyInProgress: true, followCompanyShowError: null };
    case FOLLOW_COMPANY_SUCCESS:
      return { ...state, followCompanyInProgress: false, followCompany: payload };
    case FOLLOW_COMPANY_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, followCompanyInProgress: false, followCompanyShowError: payload };
    case UPDATE_FOLLOWER_REQUEST:
      return { ...state, updateFollowerInProgress: true, followCompanyInProgress: true, updateFollowerError: null };
    case UPDATE_FOLLOWER_SUCCESS:
      return { ...state, updateFollowerInProgress: false, followCompanyInProgresss: false };
    case UPDATE_FOLLOWER_ERROR:
      return { ...state, updateFollowerInProgress: false, updateFollowerError: payload };
    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const followCompanyRequest = () => ({ type: FOLLOW_COMPANY_REQUEST });

export const followCompanySuccess = user => ({
  type: FOLLOW_COMPANY_SUCCESS,
  payload: user,
});

export const followCompanyError = e => ({
  type: FOLLOW_COMPANY_ERROR,
  payload: e,
  error: true,
});

export const updateFollowerRequest = () => ({ type: UPDATE_FOLLOWER_REQUEST });

export const updateFollowerSuccess = () => ({
  type: UPDATE_FOLLOWER_SUCCESS,
});

export const updateFollowerError = e => ({
  type: UPDATE_FOLLOWER_ERROR,
  payload: e,
  error: true,
});

// ================ Thunks ================ //

export const FollowCompany = (compId) => async (dispatch, getState, sdk) => {
  const companyId = compId?.companyId;
  const fractionalProId = compId?.fractionalProId;
  const companyListingId = compId?.companyListingId;
  const fractionalProListingId = compId?.fractionalProListingId;
  dispatch(followCompanyRequest());
  try {
    const res = await insertFollowers({ companyId, fractionalProId, companyListingId , fractionalProListingId });
    if (res) {
      dispatch(followCompanySuccess(res));
      const { currentUser } = getState().user;
      const companyIds = currentUser && currentUser?.id?.uuid || currentUser?.data?.data?.id.uuid;
      const isCompany = currentUser && currentUser.id && currentUser.attributes.profile.publicData.accountType === "company";
      dispatch(getFollowCompanyData(companyIds, 1, isCompany, true));
    }
  } catch (error) {
    dispatch(followCompanyError(storableError(error)));
  }
}

export const getFollowCompanyData = (companyId, page, isCompany,fromListingPage=false) => async (dispatch, getState, sdk) => {
  dispatch(followCompanyRequest());
  try {
    console.log( companyId, page, isCompany,' companyId, page, isCompany');
    
    const res = await getFollowers({ companyId, page, isCompany });
    if (res?.data) {
      const followersIds = (res?.data && res?.data.length > 0) ? res?.data?.map(item => isCompany ? item?.fractionalProId : item?.companyId) : [];
      const userDetails = fromListingPage
        ? true
        : await Promise.all(
          followersIds?.map(id => dispatch(showUser(id)))
        );

      if (userDetails) {
        const combinedData = {
          users: (userDetails && userDetails?.length > 0) ? userDetails?.map((user) => user?.data?.data) : [],
          followers: (res?.data && res?.data?.length > 0) ? res?.data : [],
          pagination: res?.pagination
        };
        dispatch(followCompanySuccess(combinedData));
      }
    }
  } catch (error) {
    dispatch(followCompanyError(storableError(error)));
  }
};


export const updateFollower = (followerId) => async (dispatch, getState) => {
  dispatch(updateFollowerRequest());
  try {
    const res = await updateFollowers({ _id: followerId });
    if (res?.success) {
      dispatch(updateFollowerSuccess());
      let currentUserr;
      if (getState().user?.currentUser) {
        currentUserr = getState().user?.currentUser;

      } else {
        currentUserr = await sdk.currentUser.show()
      }
      const companyId = currentUserr && currentUserr?.id?.uuid || currentUserr?.data?.data?.id.uuid;
      const isCompany = currentUserr && currentUserr.id && currentUserr.attributes.profile.publicData.accountType === "company";
      dispatch(getFollowCompanyData(companyId, 1, isCompany , false));
    }
  } catch (error) {
    dispatch(updateFollowerError(storableError(error)));
  }
};



export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  let currentUserr;
  if (getState().user?.currentUser) {
    currentUserr = getState().user?.currentUser;

  } else {
    currentUserr = await sdk.currentUser.show()
  }
  const companyId = currentUserr && currentUserr?.id?.uuid || currentUserr.data.data?.id.uuid;
  const isCompany = currentUserr && currentUserr.id && currentUserr?.attributes?.profile?.publicData.accountType === "company" || currentUserr?.data?.data?.attributes?.profile?.publicData?.accountType === "company";
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });
  const { page = 1, address, origin, ...rest } = queryParams;
  return dispatch(getFollowCompanyData(companyId, page, isCompany));
};


